import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ComingSoon from "@/pages/ComingSoon";
import CrtOverlay from "@/components/CrtOverlay";
import CustomCursor from "@/components/CustomCursor";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-[#0A0510] text-white min-h-screen">
      <CrtOverlay />
      <CustomCursor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ComingSoon />} />
          <Route path="/preview" element={<Home />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0510",
            border: "1px solid #FF007A",
            color: "#fff",
            boxShadow: "0 0 22px rgba(255,0,122,0.35)",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
          },
        }}
      />
    </div>
  );
}

export default App;
